import {
  VuexModule,
  Module,
  MutationAction,
  Mutation,
  Action,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import Log from "@/components/log";
import { env } from "@/env";
export const KEY_PEFIX = env.VUE_APP_KEY + ":";

export function getDataFromStorage(str: string | null): any {
  let result: any = null;
  try {
    result = str ? JSON.parse(str) : null;
  } catch (e) {
    Log.error(e);
  }
  return result;
}

const initAuthInfo = getDataFromStorage(
  localStorage.getItem(KEY_PEFIX + "auth")
);
const initHisTo = sessionStorage.getItem(KEY_PEFIX + "histo");

export interface ICoreState {
  auth: any;
  wxUrl: string;
}

@Module({ dynamic: true, store, name: "core" })
class Core extends VuexModule implements ICoreState {
  public auth = initAuthInfo;
  public wxUrl = null as any;
  public to: string = initHisTo as string;

  @Mutation
  public putAuth(authInfo: any) {
    if (!authInfo) {
      return;
    }
    this.auth = authInfo;
    localStorage.setItem(KEY_PEFIX + "auth", JSON.stringify(authInfo));
  }

  @Mutation
  public clearAuth() {
    this.auth = null;
    localStorage.removeItem(KEY_PEFIX + "auth");
  }

  @Mutation
  public setWxUrl(wxUrlObj: { wxUrl: string; ios: boolean }) {
    // ios只记录第一次的url
    if (wxUrlObj.ios && this.wxUrl) {
      return;
    }
    this.wxUrl = wxUrlObj.wxUrl;
  }

  @Mutation
  public storeRoute(to: string) {
    this.to = to;
    sessionStorage.setItem(KEY_PEFIX + "histo", to);
  }
}

export const CoreModule = getModule(Core);
